import { Grid, useWindowSize } from '@solinkcorp/solink-components';
import classNames from 'classnames';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import { type Device } from '../../types/device.types';
import { type Event, type VideoLinkItem } from '../../types/event.types';
import { formatDay, formatTimeOfDay } from '../../utils/helperFunctions';
import './AlarmLog.sass';

interface AlarmLogProps {
  alarmEvent: Event;
  videoLinkItems: VideoLinkItem[];
  timezoneId: string;
  handleVideoLinkItemClick: (id: string, timestamp: number, videoUrl: string) => void;
  tokenExpired: boolean;
  location?: Device;
}

const AlarmLog: React.FC<AlarmLogProps> = ({
  alarmEvent,
  videoLinkItems,
  timezoneId,
  handleVideoLinkItemClick,
  tokenExpired,
}) => {
  const { width } = useWindowSize();
  const locale = useLocale();
  let abbreviate = false;

  if (width && width < 480) {
    abbreviate = true;
  }

  if (!alarmEvent || !videoLinkItems) return null;

  let date: string | undefined = '';

  return (
    <div className="entry full-width">
      <label style={{ color: '#F29794' }}>{locale.spa.alarmLog}</label>
      <div className="text">
        <Grid
          gridTemplateRows="none"
          gridRowGap="1.25em"
          gridTemplateColumns="1fr 7fr"
          justifyItems="start"
          className="alarm-log"
        >
          {videoLinkItems.map(({ title, timestamp, cameraId, metadata }, index) => {
            // Default to date has not changed
            let dateHasChanged = false;
            const time = formatTimeOfDay({ time: timestamp, timezoneId });
            const newDate = formatDay({ time: timestamp, timezoneId, abbreviate });

            // Compare old date to newDate and see if there is a difference, show the date if it has
            if (date !== newDate) {
              date = newDate;
              dateHasChanged = true;
            }

            const clickable = !tokenExpired && cameraId && metadata?.videoUrl;
            const timeClass = classNames('time', { 'time-link': clickable });
            return (
              <React.Fragment key={index}>
                {dateHasChanged && (
                  <div className="date">
                    <span>{date}</span>
                  </div>
                )}
                <div
                  className={timeClass}
                  onClick={() =>
                    clickable
                      ? handleVideoLinkItemClick(cameraId, timestamp, metadata?.videoUrl)
                      : null
                  }
                >
                  {time}
                </div>
                <div className="item-title">{title}</div>
              </React.Fragment>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default AlarmLog;
